import * as angular from 'angular';

import { GuidHelper } from '../../framework/helpers/helpers';
import { ComponentDefinition, DigitalState } from '../../models';

class DigitalStatePickerController implements angular.IComponentController {
    id: string;
    model: number;
    modelName: string;

    readonly fullWidth: boolean;
    readonly isDisabled: boolean;
    readonly onChange: () => void;
    readonly position: 'up' | 'down' | 'auto';
    readonly states: DigitalState[];

    static $inject = ['$scope'];
    constructor(private _$scope: angular.IScope) {
        this.id = `states-${GuidHelper.getGuid()}`;
    }

    $onInit() {
        this._$scope.$watch(
            () => this.model,
            (newValue, oldValue) => {
                if (this.onChange && newValue !== undefined && newValue !== null && newValue !== oldValue) {
                    this.onChange();
                }
            }
        );
    }
}

export const wtDigitalStatePicker: ComponentDefinition = {
    componentId: 'wtDigitalStatePicker',
    controller: DigitalStatePickerController,
    template: require('./digitalStatePicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        controlName: '<?',
        fullWidth: '<?',
        isDisabled: '<?',
        model: '=',
        modelName: '<?',
        onChange: '&?',
        position: '<?',
        states: '<',
    }
};